import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_COMBO_REMOVE_AUTO_PROGRESSION_EXPERIMENT = defineFcm(
	'psf_combo_remove_auto_progression_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		deprecated:
			'FCM no longer in use — safe to delete ~1 week after this PR deploys, once old bundles stop querying the field (see CHANGE-94123)',
		context: 'PSF Combo page',
		description:
			'Experiment testing whether removing auto-redirects after sharing from the PSF Combo slide-up increases multiple shares per user',
		import: false,
		template: {
			enabled: false,
			experimentName: 'psf_combo_remove_auto_progression_experiment_v1',
		},
	});
